// Utility to get actual hex color from tenant theme name
// Maps color names from Tenant Management Service to hex values defined in color.css

const THEME_COLORS = {
  // Primary colors - used for sidebar, header backgrounds
  'grey': '#333333',
  'dark-blue': '#131921',
  'purple': '#673ab7',
  'magenta': '#e91e63',
  'red': '#f44336',
  'orange': '#ff9800',
  'green': '#4caf50',
  'lime': '#afb42b',
  'blue': '#0f3460', // fallback
  
  // Secondary colors - used for buttons, accents
  'orange-secondary': '#ff9f26',
  'lime-secondary': '#afb42b',
  'green-secondary': '#4caf50',
  'purple-secondary': '#673ab7',
  'pink-secondary': '#e91e63',
  'black-secondary': '#000000',
};

/**
 * Get primary theme color hex value from tenantInfo
 * @param {Object} tenantInfo - Tenant configuration object
 * @returns {string} Hex color code
 */
export const getPrimaryThemeColor = (tenantInfo) => {
  if (!tenantInfo || !tenantInfo.primaryColor) {
    return THEME_COLORS['grey']; // default fallback to match tenant config
  }
  return THEME_COLORS[tenantInfo.primaryColor] || THEME_COLORS['grey'];
};

/**
 * Get secondary theme color hex value from tenantInfo
 * @param {Object} tenantInfo - Tenant configuration object
 * @returns {string} Hex color code
 */
export const getSecondaryThemeColor = (tenantInfo) => {
  if (!tenantInfo || !tenantInfo.secondaryColor) {
    return THEME_COLORS['lime-secondary']; // default fallback
  }
  // Support both: API may send base name ("orange") or full key ("orange-secondary")
  const raw = tenantInfo.secondaryColor;
  const key = raw.endsWith('-secondary') ? raw : `${raw}-secondary`;
  return THEME_COLORS[key] || THEME_COLORS['orange-secondary'];
};
